/* eslint-disable max-lines */
import { AuditAuthor } from "./IAuditAuthor";
import { IStationModel } from "./IStations";

export interface IGTFSShape {
  id: number;
  name: string;
  shapeId: string;
  startingLatitude: number;
  startingLongitude: number;
  endingLatitude: number;
  endingLongitude: number;
  stationFromId: number;
  stationToId: number;
}

export interface IGTFSShapeForm {
  name: string;
  stationFromId: Partial<IStationModel>;
  stationToId: Partial<IStationModel>;
  kmlFile: FileList | null;
}

export interface IGTFSStation {
  id: number;
  name: string;
  latitude: number;
  longitude: number;
}

export interface IGTFSStationForm {
  id: Partial<IStationModel>;
  name: string;
  latitude: number;
  longitude: number;
}

export interface IGTFSTrip {
  gtfsLineId: number;
  gtfsLine: null;
  id: number;
}

export interface IGTFSLine extends AuditAuthor{
  gtfsTrips: IGTFSTrip[];
  gtfsShape: IGTFSShape;
  lineName: string;
  operatorName: string;
  id: number;
}
export interface IGTFSLineSelectItem {
  id: number;
  name: string;
}

export interface IGTFSLineCreateForm {
  lineId?: {
    label: string;
    parentValue: number;
    oldValue: number;
    value: number;
    selected: boolean;
  };
  shapeId?: IGTFSLineSelectItem;
  trips: Record<string, { id: number; selected: boolean }>;
}

export interface IGTFSLineDetailsResponse {
    gtfsTrips: IGTFSTrip[];
    gtfsShape: IGTFSShape;
    lineName: string | null;
    id: number;
}

export interface IGTFSLineUpsertForm {
  lineId: number;
  shapeId: number;
  tripIds: number[];
}

export interface IGTFSOperator {
  gjAlToken: string;
  blogId: number;
  id: number;
}

export interface IGTFSOperatorResponse {
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
  data: IGTFSOperator[];
}

export interface IGjAlRedirect{
  url: string;
  name: string;
}
export interface IGTFSUploadResult {
  feedUrl: string;
  gjAlRedirects: Record<string, IGjAlRedirect>;
}

export interface IGTFSValidationResult {
  id: number;
  feedVersion: number;
  isValid: boolean;
  errorCount: number;
  warningCount: number;
  errorsJson: string;
  warningsJson: string;
  totalAgencies: number;
  totalRoutes: number;
  totalTrips: number;
  totalStops: number;
  feedUrl: string;
  generatedAt: string;
}

export interface IGTFSEnrollmentLog {
  id: number;
  action: string;
  entityType: string;
  entityId: number;
  details: string;
  processedAt: string;
}

export enum GTFSBlockedEntityType {
  Operator = 1,
  Line = 2,
  Trip = 3
}

export interface IGTFSBlockedEntity extends AuditAuthor {
  id: number;
  entityType: GTFSBlockedEntityType;
  entityTypeName: string;
  entityId: number;
  reason: string | null;
}

export interface IGTFSBlockInsert {
  entityType: GTFSBlockedEntityType;
  entityId: number;
  reason?: string;
}

export interface IGTFSBlockTypeOption {
  value: GTFSBlockedEntityType;
  label: string;
}

export interface IGTFSBlockForm {
  entityType?: IGTFSBlockTypeOption;
  entityId: number;
  reason?: string;
}
